// extracted by mini-css-extract-plugin
module.exports = {"infinite_canvas_container":"InfiniteCanvas_infinite_canvas_container__UZaLG","infinite_canvas_box":"InfiniteCanvas_infinite_canvas_box__6OL_m"};